import { TICKET_LIST_ACTION_TYPES } from '@constants/actionTypes/tikcetListActionTypes';

export const INITIAL_STATE = {
    controller: {},
    tickets: {},
    ticketAttachments: [],
    modalFlags: {},
    ticketActiveTaskData: {},
    modalData: {},
    ticketActiveTaskFromProperties: [],
    ticketDocuments: [],
    ticketDetail: {},
    allUsersForQueue: {},
    bulkAssignmentUsers: {},
    ticketCategory: [],
    customFieldOptions: [],
    ticketAssignee: {},
    ticketRequestors: {},
    formData: {},
    errorModalData: {
        isOpen: false,
        errorMessage: '',
        modalTitle: '',
    },
    listApiType: true,
};

interface ITicketsListAction {
    type: string;
    payload?: any;
}

// Reducer function with typed state and action
export default (state = INITIAL_STATE, action: ITicketsListAction) => {
    switch (action?.type) {
        case TICKET_LIST_ACTION_TYPES.SET_TICKET_FORM_DATA:
            return {
                ...state,
                formData: { ...action.payload },
            };
        case TICKET_LIST_ACTION_TYPES.SET_TICKETS_LIST:
            return {
                ...state,
                tickets: { ...action.payload },
            };
        case TICKET_LIST_ACTION_TYPES.UPDATE_TICKETS:
            return {
                ...state,
                tickets: { ...state.tickets, ticketListJson: [...action.payload] },
            };
        case TICKET_LIST_ACTION_TYPES.SET_TICKET_ATTACHMENTS:
            return {
                ...state,
                ticketAttachments: [...action.payload],
            };
        case TICKET_LIST_ACTION_TYPES.SET_TICKET_ACTIVE_TASK_FROM_PROPERTIES_LIST:
            return {
                ...state,
                ticketActiveTaskFromProperties: [...action.payload],
            };
        case TICKET_LIST_ACTION_TYPES.SET_TICKET_DOCUMENTS:
            return {
                ...state,
                ticketDocuments: [...action.payload],
            };
        case TICKET_LIST_ACTION_TYPES.SET_TICKET_DETAILS:
            return {
                ...state,
                ticketDetail: { ...action.payload },
            };
        case TICKET_LIST_ACTION_TYPES.SET_MODAL_FLAGS:
            return {
                ...state,
                modalFlags: { ...action.payload },
            };
        case TICKET_LIST_ACTION_TYPES.SET_TICKET_ACTIVE_TASK_DATA:
            return {
                ...state,
                ticketActiveTaskData: { ...action.payload },
            };
        case TICKET_LIST_ACTION_TYPES.SET_ALL_USERS_FOR_QUEUE:
            return {
                ...state,
                allUsersForQueue: { ...action.payload },
            };

        case TICKET_LIST_ACTION_TYPES.SET_BULK_ASSIGNMENT_USERS:
            return {
                ...state,
                bulkAssignmentUsers: { ...action.payload },
            };

        case TICKET_LIST_ACTION_TYPES.SET_TICKET_CATEGORY:
            return {
                ...state,
                ticketCategory: [...action.payload],
            };
        case TICKET_LIST_ACTION_TYPES.SET_CUSTOM_FIELD_OPTIONS:
            return {
                ...state,
                customFieldOptions: [...action.payload],
            };
        case TICKET_LIST_ACTION_TYPES.SET_TICKET_ASSIGNEE:
            return {
                ...state,
                ticketAssignee: { ...action.payload },
            };
        case TICKET_LIST_ACTION_TYPES.SET_TICKET_REQUESTERS:
            return {
                ...state,
                ticketRequestors: { ...action.payload },
            };

        case TICKET_LIST_ACTION_TYPES.SET_MODALS_DATA:
            return {
                ...state,
                modalData: { ...action.payload },
            };
        case TICKET_LIST_ACTION_TYPES.SET_DEFAULT_CONTROLLER:
            return {
                ...state,
                controller: { ...action.payload },
            };
        case TICKET_LIST_ACTION_TYPES.SET_DATA_ERROR:
            return {
                ...state,
                errorModalData: { ...action.payload },
            };

        case TICKET_LIST_ACTION_TYPES.SET_TICKET_LIST_API_TYPE:
            return {
                ...state,
                listApiType: action.payload,
            };

        default:
            return state;
    }
};
